import { CardType } from '../models/skyclub.interfaces';

export const BusinessAmex: CardType = {
  name: 'Delta SkyMiles® Reserve Business American Express Card',
  terms: {
    label: '',
    url: '',
    isIcon: true,
    information:
      'Your Delta SkyMiles Reserve Card offers 15 Delta Sky Club Visits, from February 1 through January 31 of the following year. All entries made within a single 24-hour period are considered one Visit. Spend $75,000 on your Reserve Card to gain Unlimited Delta Sky Club Access, which will reflect on your account after your first Visit to a Club. Terms apply. View System Alert Banner in SkyMiles Landing page delivery'
  }
};

export const ReserveAmex: CardType = {
  name: 'Delta SkyMiles® Reserve American Express Card',
  terms: {
    label: '',
    url: '',
    isIcon: true,
    information:
      'Your Delta SkyMiles Reserve Card offers 15 Delta Sky Club Visits, from February 1 through January 31 of the following year. All entries made within a single 24-hour period are considered one Visit. Spend $75,000 on your Reserve Card to gain Unlimited Delta Sky Club Access, which will reflect on your account after your first Visit to a Club. Terms apply. View System Alert Banner in SkyMiles Landing page delivery'
  }
};

export const SkyClubAmex: CardType = {
  name: 'Delta Sky Club Membership',
  terms: {
    label: 'Terms',
    url: 'https://www.delta.com/us/en/delta-sky-club/access'
  }
};
